'use client'

import { Scissors } from "lucide-react";

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-background py-10">
      <div className="mx-auto flex max-w-[1600px] flex-col items-center justify-between gap-4 px-6 md:flex-row md:px-12">
        <div className="flex items-center gap-2">
          <Scissors className="h-3 w-3 text-rose-gold" />
          <span className="font-display text-lg">MAISON NOIR</span>
        </div>
        <p className="text-[0.7rem] uppercase tracking-editorial text-muted-foreground">
          © 2026 — Paris · New York · Tokyo
        </p>
      </div>
    </footer>
  );
}
